export const CREATE_ARCHITECTUREGOVERNMENTS = "CREATE_ARCHITECTUREGOVERNMENTS";   
export const RETRIEVE_ARCHITECTUREGOVERNMENTS = "RETRIEVE_ARCHITECTUREGOVERNMENTS";
export const RETRIEVESINGLE_ARCHITECTUREGOVERNMENTS = "RETRIEVESINGLE_ARCHITECTUREGOVERNMENTS";
export const UPDATE_ARCHITECTUREGOVERNMENTS = "UPDATE_ARCHITECTUREGOVERNMENTS";   
export const DELETE_ARCHITECTUREGOVERNMENTS = "DELETE_ARCHITECTUREGOVERNMENTS"; 